import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomerHeader from './Header/CustomerHeader';
import EhAdminHeader from './Header/EhAdminHeader';
import { allRoleNames } from '../constants/roles';
import Routes from '../constants/routes';
import LoginWorkflow from './Login/LoginWorkflow';
import { isLoggedIn } from '../helpers/accountHelper';

//display the header + page if user is logged in, else redirect them to login
class PrivateRoute extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	isInRole = () => {
		const { roles, user } = this.props;
		const { ehAdminRole, customerRole } = user;

		if (!roles) return true;

		// Validate user's roles against allRoleNames to check for a valid role
		const userRoles = [ehAdminRole, customerRole].filter((role) => allRoleNames.includes(role));

		// Allow access if any of the user's roles matches an allowed role
		return userRoles.some((role) => roles.includes(role));
	};

	loginPageWithReturnUrl = () => {
		//if we made it here, the user is not logged in and needs to be redirected to the login page
		const { pathname, search } = this.props.location;
		let currentParams = new URLSearchParams(search);
		let newParams = new URLSearchParams();

		if (pathname !== Routes.Root && pathname !== Routes.LoginPage) {
			//if username is in the params we want to remove it and reconstruct the new params
			if (currentParams.has('username')) {
				const username = currentParams.get('username');
				newParams.append('username', username);
				//remove username from props.redirecturl
				currentParams.delete('username');
			}

			newParams.append('redirectURL', pathname + '?' + currentParams.toString());
		}

		const redirectUrl = Routes.LoginPage + '?' + newParams.toString();
		return <Redirect to={redirectUrl} />;
	};

	render() {
		const { component: Component, ...rest } = this.props;

		if (isLoggedIn(this.props.user)) {
			if (this.props.user.loginWorkflow && this.props.user.loginWorkflow.steps && this.props.user.loginWorkflow.steps.length > 0) {
				return <LoginWorkflow user={this.props.user} />;
			} else {
				if (this.isInRole()) {
					return (
						<Route
							{...rest}
							render={(props) => {
								return (
									<div>
										{this.props.user.ehAdminRole && this.props.roles?.includes('Super Administrator', 'System Administrator') ? (
											<EhAdminHeader />
										) : (
											<CustomerHeader />
										)}

										<Component {...props} />
									</div>
								);
							}}
						/>
					);
				} else {
					return <Redirect to='/Forbidden' />;
				}
			}
		}
		return this.loginPageWithReturnUrl();
	}
}

PrivateRoute.propTypes = {
	user: PropTypes.object,
	location: PropTypes.object.isRequired,
	component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
	roles: PropTypes.array,
};

function mapStateToProps(state) {
	return {
		user: state.user,
	};
}

export default connect(mapStateToProps)(PrivateRoute);
